import { Component } from '@angular/core';

@Component({
  selector: 'app-airgrip-industries',
  templateUrl: './airgrip-industries.component.html',
  styleUrls: ['./airgrip-industries.component.scss']
})
export class AirgripIndustriesComponent {

}
